import React from 'react';
import { leadership } from '../../data/leadership';
import './Contact.css';

function Contact() {
  return (
    <div className="contact">
      <section className="page-hero">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you. Reach out to us through any of these channels.</p>
      </section>

      <div className="page-container">
        <section className="contact-info">
          <h2>Contact Information</h2>
          
          <div className="contact-details">
            <div className="contact-method">
              <div className="method-icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
              </div>
              <h3>Email</h3>
              <p>
                <a href="mailto:harriscountyhistoricalsociety@gmail.com">
                  harriscountyhistoricalsociety@gmail.com
                </a>
              </p>
            </div>

            <div className="contact-method">
              <div className="method-icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              </div>
              <h3>Phone</h3>
              <p>
                <a href="tel:832.839.0560">
                  832.839.0560
                </a>
              </p>
            </div>

            <div className="contact-method">
              <div className="method-icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
              </div>
              <h3>Mailing Address</h3>
              <p>
                PO Box 55776<br />
                Houston, TX 77255-5776
              </p>
            </div>
          </div>

          <div className="leadership">
            <h3>Society Leadership</h3>
            <div className="leadership-grid">
              {leadership.map((leader) => (
                <div className="leader-card" key={leader.role}>
                  <div className="leader-role">{leader.role}</div>
                  <div className="leader-name">{leader.name}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="social-links">
            <h3>Follow Us</h3>
            <div className="social-grid">
              <a href="https://www.facebook.com/HARRISCOUNTYHISTORICALSOCIETY/" className="social-button" target="_blank" rel="noopener noreferrer">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                Facebook
              </a>

            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Contact; 